<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle"></SubHeader>

    <div class="main">
      <div class="page-content">
        <div class="set-wrap">
          <div class="set-title">基本设置</div>
          <div class="set-info" @click="goPage('/user/profile')">
            <div class="t">个人信息</div>
            <div class="des">编辑资料<span class="icon"></span></div>
          </div>
        </div>

        <div class="set-wrap">
          <div class="set-title">安全设置</div>

          <div class="set-info" @click="goPage('/user/set/verify')">
            <div class="t">实名认证</div>
            <div class="des">{{Number(userInfo.account.is_idcard) === 1?'已认证':'前往认证'}}<span class="icon"></span></div>
          </div>

          <div class="set-info" @click="goPage('/user/editPwd')">
            <div class="t">修改密码</div>
            <div class="des">修改<span class="icon"></span></div>
          </div>
        </div>
        
        <div class="set-wrap">
          <div class="set-title">地址管理</div>
          <div class="set-info" @click="goPage('/user/address')">
            <div class="t">收货地址</div>
            <div class="des"><span class="icon"></span></div>
          </div>
        </div>

        <div class="set-btn" @click="loginOut">退出登录</div>
      </div>
    </div>
  </div>
</template>


<script>
import SubHeader from "../../../components/sub_header";

import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Dialog } from "vant";

Vue.use(Dialog);

export default {
  name: "user-set",
  data() {
    return {};
  },
  components: {
    SubHeader,
    [Dialog.Component.name]: Dialog.Component,
  },

  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
  methods: {
    ...mapActions({
      asyncOutLogin: "user/outLogin",
      login: "user/login",
    }),
    

    goPage(url) {

      if (!this.isLogin) {
        this.$router.push("/login");
      }

      switch (url) {
        case '/user/set/verify':
          if(Number(this.userInfo.account.is_idcard) === 1){
            // Dialog.alert({
            //   title: "提示",
            //   message: "您已认证成功！",
            //   className: "dialog-public footer-center",
            // }).then(() => {
            //   // on close
            // });
            this.$router.push(url);
          } else {
            this.$router.push(url);
          }

        break;default:
          this.$router.push(url);
        break;
      }

    },

    loginOut() {
      let vm = this;
      Dialog.confirm({
        title: "提示",
        message: "确定退出登录？",
        className: "dialog-public",
      })
        .then(() => {
          // on confirm
          vm.asyncOutLogin({
            success: () => {
              vm.$router.replace("/user");
            },
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      userInfo: (state) => state.user.userInfo,

    }),
  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}

.set-wrap {
  margin-bottom: 0.3rem;
  .set-title {
    font-size: 0.3rem;
    color: #333234;
    line-height: 1rem;
    padding: 0 0.55rem;
    font-weight: bold;
  }

  .set-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: url(../../../assets/images/user/set/bg.png) repeat-y left top;
    background-size: 100% auto;
    height: 0.8rem;
    padding: 0 0.68rem 0 0.55rem;
    margin-bottom: 0.1rem;
    &:last-child {
      margin-bottom: 0;
    }

    .t {
      font-size: 0.3rem;
      color: #333234;
    }
    .des {
      font-size: 0.3rem;
      color: #5c5c5c;
      display: flex;
      align-items: center;
      height: 100%;
      padding-right: 0.3rem;
      position: relative;

      span.icon {
        width: 0.12rem;
        height: 0.24rem;
        background: url(../../../assets/images/user/set/right.png) no-repeat
          center;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -0.12rem;
      }
    }
  }
}
.set-btn {
  margin-top: 1.65rem;
}
</style>

